import { Head, Link, usePage } from "@inertiajs/react"
import { AccountHero, DesignCard, EmptyState } from "@/components/account/AccountParts"
import { PublicShell } from "@/components/PublicShell"
import { Button } from "@/components/ui/button"
import type { AccountDesignsProps, PageProps } from "@/types/inertia"
import "@/styles/public-account.css"

const TITLE = "My designs"
const DESCRIPTION =
  "Every label you have designed in the SOH GD Wines studio. Open one to keep designing, duplicate it to try a variation, or download the mock-up again."

// My designs (/account/designs, M6 decision 12): every mock-up on the
// account, newest first, each with Open, Duplicate and Download again.
export default function AccountDesigns() {
  const { props } = usePage<PageProps<AccountDesignsProps>>()
  const { designs } = props

  return (
    <PublicShell>
      <Head title={TITLE}>
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
      </Head>

      <AccountHero
        titleId="designs-title"
        back={{ href: "/account", label: "My account" }}
        eyebrow="Your label studio"
        title="My designs"
        lede="Open a design to keep working on it, duplicate it to try a variation, or download the mock-up again. Every label is subject to graphic design approval by our team."
        actions={
          designs.length > 0 ? (
            <Button asChild variant="ghost-hairline" size="sm">
              <Link href="/studio">Design a new label</Link>
            </Button>
          ) : undefined
        }
      />

      <section className="band band-charcoal acct-band" aria-labelledby="designs-title">
        <div className="shell">
          {designs.length > 0 ? (
            <div className="acct-designs">
              {designs.map((design) => (
                <DesignCard key={design.id} design={design} />
              ))}
            </div>
          ) : (
            <EmptyState
              level={2}
              eyebrow="Nothing designed yet"
              title="No designs yet"
              action={{ href: "/studio", label: "Design a label" }}
            >
              Start from a template or bring your own artwork, and see it on the bottle. Every design you
              save or download waits for you here.
            </EmptyState>
          )}
        </div>
      </section>
    </PublicShell>
  )
}
